import { Link } from "react-router-dom";
import { useT } from "@/context/LanguageContext";
import { translations } from "@/data/translations";

export default function PrivacyPolicy() {
  const t = useT(translations.privacy);

  return (
    <div className="min-h-screen bg-[#1a1f26] text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl py-16 md:py-24">
        <Link
          to="/"
          data-testid="privacy-back-home"
          className="inline-flex items-center gap-2 text-sm text-[#b87b56] hover:text-[#d49a7a] transition-colors mb-8 uppercase tracking-wider font-medium"
        >
          ← {t.backHome}
        </Link>

        <h1
          data-testid="privacy-title"
          className="text-4xl md:text-5xl font-bold tracking-tight uppercase mb-4"
          style={{ fontFamily: "Oswald, sans-serif" }}
        >
          {t.title}
        </h1>

        <p
          data-testid="privacy-last-updated"
          className="text-sm text-slate-400 mb-12"
        >
          {t.lastUpdated}
        </p>

        <div className="space-y-10">
          <p className="text-slate-300 leading-relaxed">{t.intro}</p>

          {/* Data Collection */}
          <section data-testid="privacy-section-data-collection">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.dataCollection.title}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              {t.dataCollection.desc}
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              {t.dataCollection.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Data Usage */}
          <section data-testid="privacy-section-data-usage">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.dataUsage.title}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              {t.dataUsage.desc}
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              {t.dataUsage.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Data Storage */}
          <section data-testid="privacy-section-data-storage">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.dataStorage.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.dataStorage.desc}
            </p>
          </section>

          {/* User Rights */}
          <section data-testid="privacy-section-user-rights">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.userRights.title}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              {t.userRights.desc}
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              {t.userRights.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Contact */}
          <section data-testid="privacy-section-contact">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.contact.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.contact.desc}
            </p>
            <a
              href="mailto:mmatimer.app@gmail.com"
              className="inline-block mt-2 text-[#b87b56] hover:text-[#d49a7a] transition-colors font-medium"
            >
              mmatimer.app@gmail.com
            </a>
          </section>
        </div>
      </div>
    </div>
  );
}
